module.exports = __webpack_public_path__ + "assets/ic-nova.179b751b.svg";